User has the roles
<ul>
  @for (role of roles(); track role) {
    <li>
      {{role}}
    </li>
  }
</ul>
